@let isLarge = data.isLarge;
<div
  [class.desk:grid-cols-2]="isLarge"
  [class.desk:grid-cols-4]="!isLarge"
  class="centered-with-padding grid grid-cols-1 gap-y-6 py-7 desk:gap-3">
  @for (finition of finitions(); track $index) {
    <a
      [class.desk:h-[300px]]="!isLarge"
      [class.desk:h-[360px]]="isLarge"
      [routerLink]="finition.url"
      class="block h-56">
      <app-option-card [image]="finition.image">
        <div card-title-left>
          {{ finition.name }}
          @if (finition.description; as description) {
            <div class="text-sm font-normal" [innerHTML]="description"></div>
          }
        </div>
        <div card-title-right class="h-3 w-4 desk:h-4 desk:w-6">
          <app-svg src="assets/icons/arrow-right.svg" />
        </div>
      </app-option-card>
    </a>
  }
</div>
